import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Drug } from '../../../drug-management/models/drug';
import { ERToolService } from '../../services/er-tool.service';

import * as constants from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { routePaths } from 'src/app/config/app-constants';
import { Dropdwon } from 'src/app/internal-user/im-tool/models/column-name';
@Component({
    selector: 'app-import-wizard-search-drug',
    templateUrl: './import-wizard-search-drug.component.html',
    styleUrls: ['./import-wizard-search-drug.component.scss'],
    standalone: false
})
export class ImportWizardSearchDrugComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns = ['name', 'ndc', 'countryCode', 'source', 'system', 'strength', 'manufacturer', 'priority', 'requestor', 'age', 'action'];
  selectedRow: any;
  dataSource = new MatTableDataSource<Drug>();
  listOfCountry: Dropdwon[] = [];
  listOfDataSourceFilter: Dropdwon[] = [];
  searchText: string = ''
  //#region Pagination properties
  totalRows: number = 0;
  currentPage: number = 1;
  pageSize: number = 5;
  pageSizeOptions: number[] = [5, 10, 20, 40, 50];
  countryId: number = 0;
  dataSourceId: number = 0;
  selectedSearchCriteria: any;
  drugNameType?: number;
  //#endregion
  constructor(
    public dialogRef: MatDialogRef<ImportWizardSearchDrugComponent>,
    public dialog: MatDialog,
    private ertService: ERToolService,
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private toastService: ToastService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dataSourceId = data.dataSourceId;
    this.searchText = data.searchText;
    this.countryId = data.countryId;
    this.selectedSearchCriteria = data.selectedSearchCriteria;
    this.drugNameType = data.drugNameType;
    if (this.searchText?.length > 0)
      this.getDrugData();
    this.getCountry();
    this.getDataSourceFilter();

  }
  ngOnInit(): void {
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getDrugData();
  }
  search() {
    this.getDrugData();
  }
  getDrugData() {
    let searchDrugKey = 'SearchDrugkey'
    this.ngxLoader.start(searchDrugKey);
    this.ertService.getSearchDrugData(
      this.dataSourceId,
      this.searchText,
      this.countryId,
      this.currentPage == 0 ? 1 : this.currentPage,
      this.pageSize,
      this.selectedSearchCriteria,
      this.drugNameType
    ).subscribe((result) => {

      this.dataSource.data = result.data.drugs
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = result.data.totalRows;
      });
      this.ngxLoader.stop(searchDrugKey);
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop(searchDrugKey);

        this.toastService.openToast(
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }
  getCountry() {
    this.ngxLoader.start();
    this.ertService.getCountry().subscribe((result) => {
      this.ngxLoader.stop();
      this.listOfCountry = result.data;
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();

        this.toastService.openToast(
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }
  getDataSourceFilter() {
    this.ngxLoader.start();
    this.ertService.getDataSourceFilter().subscribe((result) => {
      this.ngxLoader.stop();
      this.listOfDataSourceFilter = result.data;
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();

        this.toastService.openToast(
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }

  redirectToDetailsPage(rowId: any, dataSourceId: number) {
    this.route.navigate([`/${routePaths.ER_TOOL}/drug-details`, rowId, dataSourceId,'']);
    this.dialogRef.close();
  }
}
